












import { Component, Vue } from 'vue-property-decorator';
import { mapMutations, mapState } from 'vuex';

import PrivacyPolicy from './PrivacyPolicy.vue';
import Tos from './Tos.vue';
import CloseIcon from './CloseIcon.vue';

@Component({
  components: {
    Tos,
    PrivacyPolicy,
    CloseIcon,
  },
  computed: {
    ...mapState(['isFirstPage']),
  },
  methods: mapMutations(['markFirstPage']),
})
export default class Legal extends Vue {
  private isFirstPage: boolean = this.isFirstPage;

  private markFirstPage: () => void = this.markFirstPage;

  private handleClose() {
    if (this.isFirstPage) {
      this.markFirstPage();
      this.$router.replace('/');
    } else {
      this.$router.go(-1);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Legal.vue